/**
 * FoodPulseJourneyNav — audit remediation Phase 2.
 *
 * The audit's core structural recommendation is to consolidate FoodPulse
 * around five user journeys instead of dozens of competing categories.
 * This tiny nav rail surfaces them consistently at the top of every
 * key FoodPulse page. Slot it below the header on landing pages.
 *
 *   1. Discover Food
 *   2. Understand Your Food
 *   3. Find Food Nearby
 *   4. Reduce & Share
 *   5. Recipes & Cooking
 */
import { Link } from "react-router-dom";
import { Compass, ScanLine, MapPin, Recycle, Utensils } from "lucide-react";

// Each journey key routes to its dedicated landing page, which pulls
// cornerstone guides, tools, and directory slices in one place.
const JOURNEYS = [
  { key: "discover",  label: "Discover",   sub: "Encyclopedia", to: "/food-pulse/journeys/discover",   Icon: Compass },
  { key: "understand",label: "Understand", sub: "Label Scanner",to: "/food-pulse/journeys/understand", Icon: ScanLine },
  { key: "nearby",    label: "Nearby",     sub: "Deals & shops",to: "/food-pulse/journeys/nearby",     Icon: MapPin },
  { key: "share",     label: "Share",      sub: "Reduce waste", to: "/food-pulse/journeys/share",      Icon: Recycle },
  { key: "cook",      label: "Cook",       sub: "Recipes",      to: "/food-pulse/journeys/cook",       Icon: Utensils },
];

export default function FoodPulseJourneyNav({ active, className = "" }) {
  return (
    <nav
      className={`w-full border-y border-emerald-100 bg-emerald-50/40 ${className}`}
      aria-label="Primary FoodPulse journeys"
      data-testid="fp-journey-nav"
    >
      <ul className="mx-auto flex max-w-6xl snap-x snap-mandatory items-stretch gap-1 overflow-x-auto px-2 py-2 text-xs">
        {JOURNEYS.map(({ key, label, sub, to, Icon }) => {
          const isActive = active === key;
          return (
            <li key={key} className="shrink-0 snap-start">
              <Link
                to={to}
                data-testid={`fp-journey-${key}`}
                className={`flex flex-col items-start gap-0 rounded-lg px-3 py-1.5 transition-colors ${
                  isActive
                    ? "bg-emerald-600 text-white"
                    : "bg-white text-emerald-900 hover:bg-emerald-100"
                }`}
              >
                <span className="flex items-center gap-1.5 font-semibold">
                  <Icon className="h-3.5 w-3.5" aria-hidden="true" />
                  {label}
                </span>
                <span className={`text-[10px] ${isActive ? "text-emerald-100" : "text-emerald-700/80"}`}>
                  {sub}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
